import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApplicationType } from "../../entity/ApplicationType";
import { Technology } from "../../entity/Technology";
import { TechnologyCategory } from "../../entity/TechnologyCategory";
import { ShowroomMatCardViewModel } from "../components/home/showroom/showroom-mat-card/showroom-mat-card.view-model";
import { ShowroomViewModel } from "../components/home/showroom/showroom.view-model";
import { TechnologyCategoryNavHomeViewModel } from "../components/nav-bar/nav-bar.view-model";
import { AbstractCRUDService } from "./AbstractCRUDService";
import { ImageService } from "./ImageService";
import { TechnologyService } from "./TechnologyService";

@Injectable()
export class TechnologyCategoryService extends AbstractCRUDService<TechnologyCategory, number> {

	private readonly imageService: ImageService;

	private constructor(httpClient: HttpClient, imageService: ImageService) {
		super(httpClient);
		this.imageService = imageService;
	}

	public async getAllAsync(): Promise<TechnologyCategory[]> {
		return [
			{
				description: "Organic and Flexible Photovoltaics (OPV) has seen both technical innovation and market growth in the past two years. There have been significant breakthroughs in efficiency and in semi-transparent modules, detailed environmental impact studies are available, and lifetimes up to 20 years have been reported. Production capacity has increased, flexible OPV modules can be bought online for a low price, and more building integration installations have been built.",
				id: 1,
				name: "Energy",
				image: await this.imageService.getByIdAsync("technology-category/organic-photovoltaics"),
				subTitle: "Organic and flexible photovoltaics",
			},
			{
				description: "While OLED displays are the biggest success story in OPE for the moment as rigid, glass-based displays, flexible or conformable displays are starting to become more widespread as well. Curved OLED displays are already being used in products such as TVs, mobile phones and watches, and conformable, glass-free LCDs are being integrated onto support pillars in cars as prototypes.",
				id: 2,
				name: "Interaction",
				image: await this.imageService.getByIdAsync("technology-category/flexible-displays"),
				subTitle: "OLED displays",
			},
			{
				description: "OLED lighting is moving from an expensive “design” option into more mainstream architectural lighting as prices are beginning to come down. Non-planar and bendable lighting has appeared in initial products, such as automotive taillights and bendable OLED lighting panels.",
				id: 3,
				name: "Light",
				image: await this.imageService.getByIdAsync("technology-category/oled-lighting"),
				subTitle: "OLED and novel lighting",
			},
			{
				description: "The electronics and components encompass integrated smart systems to products" +
				" and prototypes that integrate multiple functionality and multiple technologies to create added value. An important development in the last few years has been the increasing importance of the Internet of Things (IoT), in which everyday objects have functionality. The hybrid system integration of printed electronics, e.g. for sensing, interconnects, antennas and energy harvesting/storage, with the computing power of small silicon chips is becoming recognized as an area where OPE can be a true enabler. Wearable health and wellbeing applications, for which the form factor of OPE is a strong advantage, are also emerging, including applications such as cardiovascular or medication compliance monitoring and enhanced bandages.",
				id: 4,
				name: "Intelligence",
				image: await this.imageService.getByIdAsync("technology-category/electronics-and-components"),
				subTitle: "novel Electronics & Components and Integrated Smart Systems",
			},
			/*{
				description: "Integrated smart systems refers to products and prototypes that integrate multiple functionality and multiple technologies to create added value. An important development in the last few years has been the increasing importance of the Internet of Things (IoT), in which everyday objects have functionality. The hybrid system integration of printed electronics, e.g. for sensing, interconnects, antennas and energy harvesting / storage, with the computing power of small silicon chips is becoming recognized as an area where OPE can be a true enabler. Wearable health and wellbeing applications, for which the form factor of OPE is a strong advantage, are also emerging, including applications such as cardiovascular or medication compliance monitoring and enhanced bandages.",
				id: 5,
				name: "Intelligence",
				image: await this.imageService.getByIdAsync("technology-category/integrated-smart-systems"),
				subTitle: "Integrated Smart Systems",
			},*/
		];
	}

	public async getByIdAsync(id: number): Promise<TechnologyCategory> {
		const request: TechnologyCategory[] = await this.getAllAsync();
		for (const technologyCategory of request) {
			if (technologyCategory.id === id) {
				return technologyCategory;
			}
		}
		throw Error("TechnologyCategory.Id not found");
	}

	public async getShowroomComponentAsync(): Promise<ShowroomViewModel> {
		return {
			showroomMatCardViewModels: (await this.getAllAsync()).map((technologyCategory: TechnologyCategory): ShowroomMatCardViewModel =>
				({
					technologyCategoryDescription: technologyCategory.description,
					technologyCategoryId: technologyCategory.id,
					technologyCategoryImage: technologyCategory.image,
					technologyCategoryName: technologyCategory.name,
					technologyCategorySubTitle: technologyCategory.subTitle,
				})),
		};
	}

	public async getNavHomeComponentAsync(): Promise<TechnologyCategoryNavHomeViewModel[]> {
		return (await this.getAllAsync()).map((technologyCategory: TechnologyCategory): TechnologyCategoryNavHomeViewModel =>
			({
				technologyCategoryId: technologyCategory.id,
				technologyCategoryName: technologyCategory.name,
			}));
	}

	public async getTechnologiesComponent(id: number): Promise<TechnologyCategory> {
		return this.getByIdAsync(id);
	}

	public async getTechnologiesComponentAsync(technologyService: TechnologyService, applicationType: ApplicationType): Promise<TechnologyCategory[]> {
		const technologies: Technology[] = await technologyService.getAllByApplicationTypeAsync(applicationType);
		const result: Map<number, TechnologyCategory> = new Map<number, TechnologyCategory>();
		for (const technology of technologies) {
			for (const technologyCategory of technology.technologyCategories) {
				result.set(technologyCategory.id, technologyCategory);
			}
		}
		return Array.from(result.values());
	}

}



// WEBPACK FOOTER //
// ./Frontend/src/app/services/TechnologyCategoryService.ts